import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const SavePdfFileRequest = (userId, stream, tempFilePath) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RepositoryPdf/SavePdfFile`,
	data: { userId, stream, tempFilePath }
});

export const GetRepositoryFilesRequest = (userId, stream) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}RepositoryPdf/GetRepositoryFiles`,
	params: { userId, stream }
});

export const DownloadRepositoryFileRequest = (userId, tableId, filename) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RepositoryPdf/DownloadRepositoryFile`,
	params: { userId, tableId, filename }
});

export const RemoveRepositoryFileRequest = (userId, tableId, filename) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RepositoryPdf/RemoveRepositoryFile`,
	params: { userId, tableId, filename }
});

export const GetPdfInformationRequest = (userId, tableId, filename) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RepositoryPdf/GetPdfInformation`,
	params: { userId, tableId, filename }
});
